import { styled } from '@mui/material';
import { useMemo } from 'react';
import { breakpoints, DisplayCard } from 'src/ui-components';

import { infoBlock } from '../../helpers/const';
import { useGetHideMetrics } from '../../hooks/useGetHideMetrics';
import { BlockData } from './components/BlockData';

export const InfoBlocks = () => {
  const { hideMetrics } = useGetHideMetrics();

  const metrics = useMemo(() => {
    return infoBlock
      .map((block) => {
        const filteredBlocks = block.blocks.filter((m) => !hideMetrics[m.field]);
        return {
          ...block,
          blocks: filteredBlocks,
        };
      })
      .filter((b) => b.blocks.length > 0);
  }, [hideMetrics]);

  return (
    <WrapperInfo>
      {metrics.map((infoBlock, index) => (
        <DisplayCard title={infoBlock.title} key={index}>
          <DisplayCard.Content w={'100%'}>
            <BlockWrapper>
              {infoBlock.blocks.map((block, blockIndex) => (
                <BlockData block={block} key={blockIndex} />
              ))}
            </BlockWrapper>
          </DisplayCard.Content>
        </DisplayCard>
      ))}
    </WrapperInfo>
  );
};

const WrapperInfo = styled('div')`
  grid-column: 1 / 3;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  ${breakpoints.before.desktop} {
    grid-template-columns: 1fr 1fr;
    grid-column: 1 / 1;
  }

  ${breakpoints.before.mobile} {
    grid-template-columns: 1fr;
  }
`;

const BlockWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
